<template>
  <p>Home</p>
</template>

<script>
export default {};
</script>

<style></style>
